/**
 * Constants for session replay event sender
 */

// Session timeout values
export const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes
export const MAX_SESSION_LENGTH = 30 * 60 * 1000; // 30 minutes
export const PAUSE_THRESHOLD = 5 * 60 * 1000; // 5 minutes

// Batch settings
export const MAX_PAYLOAD_SIZE = 500 * 1024; // 500KB per request
export const MIN_BATCH_EVENT_COUNT = 12; // Minimum events before sending a batch
// Final-send chunks must each fit the browser keepalive budget (~64KB shared
// across ALL in-flight keepalive fetches + beacons); 48KB leaves margin for
// the concurrent backup beacon and UTF-8 vs char-count skew.
export const KEEPALIVE_SAFE_BYTES = 48 * 1024;
// Cap on the localStorage retry queue for failed final chunks (~1.5MB)
export const PENDING_CHUNKS_MAX_BYTES = 1500 * 1024;

// Idle check interval
export const IDLE_CHECK_INTERVAL = 30000; // 30 seconds

// Network tracking
export const MAX_NETWORK_ENDPOINTS = 50; // Cap unique endpoints per session to limit memory
